import antdEnUS from 'antd/es/locale/en_US';
import antdZhCn from 'antd/es/locale/zh_CN';
import antdFrFR from 'antd/es/locale/fr_FR';
import antdJaJP from 'antd/es/locale/ja_JP';
import antdRoRO from 'antd/es/locale/ro_RO';
import antdRuRU from 'antd/es/locale/ru_RU';
import en from './locales/en_US.json'
import zh from './locales/zh_CN.json'
import fr from './locales/fr_FR.json'
import ja from './locales/ja_JP.json'
import ro from './locales/ro_RO.json'
import ru from './locales/ru_RU.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { THEME_CONFIG } from 'configs/AppConfig';

export const resources = {
    en: {
        translation: en,
        antd: antdEnUS
    },
    zh: {
        translation: zh,
        antd: antdZhCn
    },
    fr: {
        translation: fr,
        antd: antdFrFR
    },
    ja: {
        translation: ja,
        antd: antdJaJP
    },
    ro: {
        translation: ro,
        antd: antdRoRO
    },
    ru: {
        translation: ru,
        antd: antdRuRU
    },
}

const savedLanguage = localStorage.getItem('appLanguage') || THEME_CONFIG.locale;
i18n.use(initReactI18next).init({
    resources,
    fallbackLng: savedLanguage,
    lng: savedLanguage,
    interpolation: {
        escapeValue: false 
    }
})

export default i18n;